import React from 'react';
import CardItem from './Items/CardItem';
import { SOURCE_URL } from '../../../config';
import { IPriceOption, PackInfo, Plan } from '../types';
import { useAppDispatch, useAppSelector } from '../../../stores/hook';
import { setPackInfo, setSubscribeModalStatus } from './GetStartedSlice';
import translations from '../../../text/get-started-translations.json';
import language from '../../../utils/LanguageSettings';
import { appendUtmParams } from '../../../utils/Url';

interface FeaturePlanProps {
    plans: Array<Plan>;
}

const FeaturePlan: React.FC<FeaturePlanProps> = ({ plans }) => {
    const pageTranslations = translations[language];
    const isTvBoxPage = useAppSelector((state) => state.getStarted.isTvBoxPage);
    const isRecommendationPage = useAppSelector((state) => state.getStarted.isRecommendationPage);
    const link = window.myAppStrapi?.phpButtonLink || '';
    const campaignCodes = window.myAppStrapi?.campaignCodeArray || {};
    const campaignCodeMap = new Map(Object.entries(campaignCodes));
    const dispatch = useAppDispatch();

    const onClickBtn = (e: React.MouseEvent<HTMLButtonElement>, packInfo: PackInfo) => {
        if (packInfo.PriceOptions?.length > 1) {
            dispatch(setSubscribeModalStatus(true));
            dispatch(setPackInfo(packInfo));
        } else if (packInfo.PriceOptions?.length === 1) {
            const campaign = packInfo.PriceOptions[0].Campaign;
            if (campaign) {
                if (isTvBoxPage || isRecommendationPage) {
                    const cpm = campaignCodeMap.get(campaign);
                    if (cpm) {
                        const d = new Date();
                        d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
                        document.cookie = `cpm=${cpm}; expires=${d.toUTCString()}; SameSite=None; Secure; domain=.nowtv.now.com; path=/`;
                        window.location.href = link;
                    }
                } else {
                    const url = `https://ssp.nowtv.now.com/choose-plan?campaign=${campaign}&lang=${language}`;
                    window.location.href = appendUtmParams(url);
                }
            }
        }
    };

    const renderCardItem = (pack: Plan, isFeatured: boolean) => {
        const sourceUrl = `${SOURCE_URL}`;
        return (
            <CardItem
                key={pack.id}
                imgSrc={pack.attributes?.plan_img?.data?.attributes?.formats?.large?.url ? `${sourceUrl}${pack.attributes.plan_img.data.attributes.formats.large.url}` : ''}
                imgSrcFeat={pack.attributes?.featureImage?.data?.attributes?.url ? `${sourceUrl}${pack.attributes.featureImage.data.attributes.url }` : ''}
                title={pack.attributes.name}
                campaignParameter={pack.attributes.campaignParameter}
                featured={isFeatured}
                description={pack.attributes.description}
                includes={pack.attributes.includes}
                price={pack.attributes.price}
                stb_price={pack.attributes.stb_price}
                ott_12Mth_price={pack.attributes.ott_12Mth_price}
                stb_12Mth_price={pack.attributes.stb_12Mth_price}
                ottPriceDetail={pack.attributes.ottPriceDetail || ''}
                stbPriceDetail={pack.attributes.stbPriceDetail || ''}
                ottCampaign={pack.attributes.ott_campaign}
                stbCampaign={pack.attributes.stb_campaign}
                stb_12M_campaign={pack.attributes.stb_12M_campaign}
                PriceOptions={pack.attributes.PriceOptions}
                box_detail_id={pack.attributes.stb_detail_id}
                Tagline={(isTvBoxPage || isRecommendationPage) ? pack.attributes.TaglineSTB : pack.attributes.TaglineOTT}
                onClick={(e) => {
                    const packInfo: PackInfo = { name: pack.attributes.name, PriceOptions: pack.attributes?.PriceOptions, optionsContext: pack.attributes.optionsContext };
                    onClickBtn(e, packInfo);
                }}
            />
        );
    };

    const planGroups = [];
    let currentRow: Plan[] = [];
    let singleItemBuffer: Plan[] = [];

    plans.forEach((pack, i) => {
        const isFeatured = isRecommendationPage ? false : isTvBoxPage ? pack.attributes.featuredSTB : pack.attributes.featured;

        if (isFeatured || currentRow.length === 2) {
            if (currentRow.length > 0) {
                planGroups.push(
                    <div key={`group-${i}`} className={isRecommendationPage ? "row recommendation" : "row"}>
                        {currentRow.map((pack) => renderCardItem(pack, isFeatured))}
                    </div>
                );
            }
            currentRow = [];
        }

        currentRow.push(pack);

        if (isFeatured) {
            planGroups.push(
                <div key={`group-${i}`} className={isRecommendationPage ? "row recommendation" : "row"}>
                    {currentRow.map((pack) => renderCardItem(pack, isFeatured))}
                </div>
            );
            currentRow = [];
        }

        if (currentRow.length === 1 && !isFeatured) {
            singleItemBuffer.push(currentRow[0]);
            currentRow = [];
        }

        if (singleItemBuffer.length === 2) {
            planGroups.push(
                <div key={`group-single-${i}`} className={isRecommendationPage ? "row recommendation" : "row"}>
                    {singleItemBuffer.map((pack) => renderCardItem(pack, isFeatured))}
                </div>
            );
            singleItemBuffer = [];
        }
    });

    if (currentRow.length > 0) {
        planGroups.push(
            <div key={`group-last`} className={isRecommendationPage ? "row recommendation" : "row"}>
                {currentRow.map((pack) => renderCardItem(pack, isRecommendationPage ? false : isTvBoxPage ? pack.attributes.featuredSTB : pack.attributes.featured))}
            </div>
        );
    }

    if (singleItemBuffer.length > 0) {
        planGroups.push(
            <div key={`group-single-last`} className={isRecommendationPage ? "row recommendation" : "row"}>
                {singleItemBuffer.map((pack) => renderCardItem(pack, isRecommendationPage ? false : isTvBoxPage ? pack.attributes.featuredSTB : pack.attributes.featured))}
            </div>
        );
    }

    return (
        <>
            {plans.length > 0 ? planGroups : <p></p>}
        </>
    );
};

export default FeaturePlan;